import { createAxios, createAxiosWithToken } from "./createAxios";
import { getLoginInfo } from "../auth/getLoginInfo";

export async function GetAllRegisteredAdmin(param) {
    let loginData = getLoginInfo();
    if (loginData)
        return await createAxiosWithToken(loginData.token).get("/OPDRegistered/GetAllRegisteredAdmin?UserId=" + param.UserId + "&PageNo=" + param.PageNo + "&PageSize=" + param.PageSize + "&SearchTerm=" + param.SearchTerm + "&FromDate=" + param.FromDate + "&ToDate=" + param.ToDate)
}

export async function GetTodaysRegisteredAdmin(param) {
    let loginData = getLoginInfo();
    if (loginData)
        return await createAxiosWithToken(loginData.token).get("/OPDRegistered/GetTodaysRegisteredAdmin?UserId=" + param.UserId + "&CenterId=" + param.CenterId + "&PageNo=" + param.PageNo + "&PageSize=" + param.PageSize + "&SearchTerm=" + param.SearchTerm)
}

export async function GetAllConfirmedAdmin(param) {
    let loginData = getLoginInfo();
    if (loginData)
        return await createAxiosWithToken(loginData.token).get("/OPDRegistered/GetAllConfirmedAdmin?UserId=" + param.UserId + "&PageNo=" + param.PageNo + "&PageSize=" + param.PageSize + "&SearchTerm=" + param.SearchTerm + "&FromDate=" + param.FromDate + "&ToDate=" + param.ToDate)
}

export async function GetTodaysConfirmedAdmin(param) {
    let loginData = getLoginInfo();
    if (loginData)
        return await createAxiosWithToken(loginData.token).get("/OPDRegistered/GetTodaysConfirmedAdmin?UserId=" + param.UserId + "&CenterId=" + param.CenterId + "&PageNo=" + param.PageNo + "&PageSize=" + param.PageSize + "&SearchTerm=" + param.SearchTerm)
}

export async function GetConfirmedHistoryByMobileNoAdmin(param) {
    let loginData = getLoginInfo();
    if (loginData)
        return await createAxiosWithToken(loginData.token).get("/OPDRegistered/GetConfirmedHistoryByMobileNoAdmin?UserId=" + param.UserId + "&Mobile=" + param.Mobile + "&PageNo=" + param.PageNo + "&PageSize=" + param.PageSize + "&SearchTerm=" + param.SearchTerm)
}

export async function GetAllRegistered(param) {
    let loginData = getLoginInfo();
    if (loginData)
        return await createAxiosWithToken(loginData.token).get("/OPDRegistered/GetAllRegistered?PageNo=" + param.PageNo + "&PageSize=" + param.PageSize + "&SearchTerm=" + param.SearchTerm + "&FromDate=" + param.FromDate + "&ToDate=" + param.ToDate)
}

export async function GetTodaysRegistered(param) {
    let loginData = getLoginInfo();
    if (loginData)
        return await createAxiosWithToken(loginData.token).get("/OPDRegistered/GetTodaysRegistered?CenterId=" + param.CenterId + "&PageNo=" + param.PageNo + "&PageSize=" + param.PageSize + "&SearchTerm=" + param.SearchTerm)
}

export async function GetAllConfirmed(param) {
    let loginData = getLoginInfo();
    if (loginData)
        return await createAxiosWithToken(loginData.token).get("/OPDRegistered/GetAllConfirmed?PageNo=" + param.PageNo + "&PageSize=" + param.PageSize + "&SearchTerm=" + param.SearchTerm + "&FromDate=" + param.FromDate + "&ToDate=" + param.ToDate)
}

export async function GetAllEmergency(param) {
    let loginData = getLoginInfo();
    if (loginData)
        return await createAxiosWithToken(loginData.token).get("/OPDRegistered/GetAllEmergency?PageNo=" + param.PageNo + "&PageSize=" + param.PageSize + "&SearchTerm=" + param.SearchTerm + "&FromDate=" + param.FromDate + "&ToDate=" + param.ToDate)
}

export async function GetTodaysConfirmed(param) {
    let loginData = getLoginInfo();
    if (loginData)
        return await createAxiosWithToken(loginData.token).get("/OPDRegistered/GetTodaysConfirmed?CenterId=" + param.CenterId + "&PageNo=" + param.PageNo + "&PageSize=" + param.PageSize + "&SearchTerm=" + param.SearchTerm)
}

export async function GetTodaysEmergency(param) {
    let loginData = getLoginInfo();
    if (loginData)
        return await createAxiosWithToken(loginData.token).get("/OPDRegistered/GetTodaysEmergency?CenterId=" + param.CenterId + "&PageNo=" + param.PageNo + "&PageSize=" + param.PageSize + "&SearchTerm=" + param.SearchTerm)
}

export async function GetConfirmedHistoryByMobileNo(param) {
    let loginData = getLoginInfo();
    if (loginData)
        return await createAxiosWithToken(loginData.token).get("/OPDRegistered/GetConfirmedHistoryByMobileNo?Mobile=" + param.Mobile + "&PageNo=" + param.PageNo + "&PageSize=" + param.PageSize)
}

export async function GetPatientInTheCabin(param) {
    let loginData = getLoginInfo();
    if (loginData)
        return await createAxiosWithToken(loginData.token).get("/OPDRegistered/GetPatientInTheCabin?DoctorId=" + param.DoctorId + "&CenterId=" + param.CenterId)
}
export async function GetPatientWhoNext(param) {
    let loginData = getLoginInfo();
    if (loginData)
        return await createAxiosWithToken(loginData.token).get("/OPDRegistered/GetPatientWhoNext?DoctorId=" + param.DoctorId + "&CenterId=" + param.CenterId)
}

export async function AddOnline(param) {
    return await createAxios().post("/OPDRegistered/AddOnline", param)
}

export async function AddOfline(param) {
    let loginData = getLoginInfo();
    if (loginData)
        return await createAxiosWithToken(loginData.token).post("/OPDRegistered/AddOfline", param)
}

export async function ConfirmOnline(param) {
    let loginData = getLoginInfo();
    if (loginData)
        return await createAxiosWithToken(loginData.token).post("/OPDRegistered/ConfirmOnline?Id=" + param.Id + "&Comment=" + param.Comment + "&BloodPressure=" + param.BloodPressure)
}

export async function SendEmergencyInCurrentQueue(param) {
    let loginData = getLoginInfo();
    if (loginData)
        return await createAxiosWithToken(loginData.token).post("/OPDRegistered/SendEmergencyInCurrentQueue?Id=" + param.Id)
}

export async function Edit(param) {
    let loginData = getLoginInfo();
    if (loginData)
        return await createAxiosWithToken(loginData.token).post("/OPDRegistered/Edit", param)
}

export async function NextPatient(param) {
    let loginData = getLoginInfo();
    if (loginData)
        return await createAxiosWithToken(loginData.token).post("/OPDRegistered/NextPatient?CenterId=" + param.CenterId + "&Note=" + param.Note)
}

export async function SetToAbsent(param) {
    let loginData = getLoginInfo();
    if (loginData)
        return await createAxiosWithToken(loginData.token).post("/OPDRegistered/SetToAbsent?CenterId=" + param.CenterId + "&Id=" + param.Id)
}

export async function PatientUnavailable(param) {
    let loginData = getLoginInfo();
    if (loginData)
        return await createAxiosWithToken(loginData.token).post("/OPDRegistered/PatientUnavailable?CenterId=" + param.CenterId + "&Id=" + param.Id)
}

export async function GetRegisterStatus(param) {
    return await createAxios().get("/OPDRegistered/GetRegisterStatus?Id=" + param.Id)
}

export async function GetConfirmedStatus(param) {
    return await createAxios().get("/OPDRegistered/GetConfirmedStatus?Id=" + param.Id)
}

//New Features
export async function GetForDateRegistered(param) {
    let loginData = getLoginInfo();
    if (loginData)
        return await createAxiosWithToken(loginData.token).get("/OPDRegistered/GetForDateRegistered?CenterId=" + param.CenterId + "&PageNo=" + param.PageNo + "&PageSize=" + param.PageSize + "&SearchTerm=" + param.SearchTerm + "&ForDate=" + param.ForDate)
}
export async function GetForDateConfirmed(param) {
    let loginData = getLoginInfo();
    if (loginData)
        return await createAxiosWithToken(loginData.token).get("/OPDRegistered/GetForDateConfirmed?CenterId=" + param.CenterId + "&PageNo=" + param.PageNo + "&PageSize=" + param.PageSize + "&SearchTerm=" + param.SearchTerm + "&ForDate=" + param.ForDate)
}

export async function GetForDateEmergency(param) {
    let loginData = getLoginInfo();
    if (loginData)
        return await createAxiosWithToken(loginData.token).get("/OPDRegistered/GetForDateEmergency?CenterId=" + param.CenterId + "&PageNo=" + param.PageNo + "&PageSize=" + param.PageSize + "&SearchTerm=" + param.SearchTerm + "&ForDate=" + param.ForDate)
}






































































